import type React from 'react';

import { Select } from '@frontend/legacy-components';

import type { Group, OrgsType, SelectorValue } from '../types';

type OrganizationSelectorPropTypes = {
  id: string;
  orgIds: OrgsType;
  onChange: (arg0: OrgsType) => void;
  userGroupMembers?: { group: Group }[];
};

const OrganizationSelector: React.FC<OrganizationSelectorPropTypes> = ({
  id,
  orgIds,
  onChange,
  userGroupMembers,
}) => {
  const options = (userGroupMembers || []).map((groupMember) => ({
    label: groupMember.group.businessName,
    value: groupMember.group.id,
  }));

  const labelLookup = (id: number): string | undefined =>
    options.find((opt) => opt.value === id)?.label;

  return (
    <Select
      id={id}
      placeholder="Select organization(s)"
      colorScheme="select"
      options={options}
      isMulti={true}
      value={(orgIds || [])
        .map((id: number) => ({ value: id, label: labelLookup(id) }))
        .filter((value) => !!value.label)}
      onChange={(values: SelectorValue<number>[] | null) =>
        onChange(
          values && values.map((val: SelectorValue<number>) => val.value),
        )
      }
      isClearable={false}
    />
  );
};

export default OrganizationSelector;
